import React, { useEffect, useState } from 'react';
import './Inverment.scss';
import PieChart from '../../commons/pie-chart/PieChart';

const Inverment = ({ funds, investmentChart, information }) => {
  const [currentFund, setCurrentFund] = useState("");
  const [load, setLoad] = useState(false);
  const [arrayPies, setArrayPies] = useState([]);
  const [currentDateRange, setCurrentDateRange] = useState("");

  useEffect(() => {
    if (!funds || !funds.list || !investmentChart || !funds.dateRange) {
      setArrayPies([]);
      setLoad(false);
      setCurrentDateRange("");
      return;
    }

    const activeFund = funds.list.find(item => item.active === true);
    const currentFund = funds.list.length > 0 ? activeFund?.id : '';

    const arrayPies = funds.list.map((itemX) => {
      const temporal = investmentChart.filter(itemY => itemY.fondo === itemX.id);
      return {
        pie: temporal,
        foundId: itemX.id
      };
    });

    const currentDateRange = funds.dateRange.length > 0 ? funds.dateRange[0].text : "";
    setCurrentFund(currentFund);
    setLoad(true);
    setArrayPies(arrayPies);
    setCurrentDateRange(currentDateRange);

  }, [funds, investmentChart]);

  const renderPie = () => {
    if (load) {
      return arrayPies.map((item, index) => {
        if (item.foundId === currentFund) {
          return (
            <div key={index}>
              <PieChart data={item.pie} identificador="5" />
            </div>
          );
        }
        return null;
      });
    } else {
      return <p>loading ...</p>;
    }
  };

  const onChangeValue = (name, value) => {
    const range = funds.dateRange.find(item => item.fund_id === value);
    if (value !== currentFund) {
      setCurrentFund(value);
      setCurrentDateRange(range?.text || "");
    }
  };


  return (
    <div id={'en-que-invirtio-afp'} className={`container hbi-section-inverment grafico5`}>
      <div className={`text-center`}>
        <h2>{information.title}</h2>
        <p>
          {information.subTitle} / <strong>{currentDateRange}</strong>
        </p>
      </div>
      <div className={`hbi-content-tabs-fondo`}>
        <ul className={`hbi-tabs-fondo`}>
          {funds.list.map(fund => (
            <li
              key={fund.id}
              className={`hbi-item-fondo ${currentFund === fund.id ? "hbi-item-fondo--active" : ""}`}
              onClick={() => onChangeValue("currentFund", fund.id)}
            >
              {fund.name}
            </li>
          ))}
        </ul>
      </div>
      {renderPie()}
    </div>
  );
}

export default Inverment;